// Support view: an admin's read-only look at a customer's project (docs/support-view-plan.md). The
// page is the normal project page at another address; that address is what makes every project,
// scenario and layer request ask the server for Support view. The server decides what is allowed:
// hiding a control here is tidiness, not protection.
export const supportViewPath = (projectId, scenarioId) =>
  `/support-view/projects/${projectId}${scenarioId ? `?scenario=${scenarioId}` : ""}`;

export const isSupportView = () => window.location.pathname.startsWith("/support-view/");

export const SUPPORT_VIEW_HEADER = "x-cdt-support-view";

export const isSupportViewApiPath = (path) => /^\/(projects|scenarios|layers)(\/|$)/.test(path);
